import cogsData from '../cogs.json';
import {
  COG_DEPARTMENTS,
  COG_KEY_OVERRIDES,
  COG_OPTIONS,
  DEFENSE_BY_LEVEL,
  HP_BY_LEVEL,
} from '../data/cogs';
import { cogImageContext, getImageFromContext } from './images';

const toCogKey = (value) =>
  COG_KEY_OVERRIDES[value] ??
  value.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());

const COG_META = COG_OPTIONS.map((option, index) => ({
  ...option,
  department: COG_DEPARTMENTS[index % 4] ?? null,
  cogKey: toCogKey(option.value),
}));

export const getCogRank = (value) => {
  const optionIndex = COG_META.findIndex((option) => option.value === value);
  if (optionIndex < 0) return null;
  return Math.floor(optionIndex / 4) + 1;
};

export const getCogDepartment = (value) => {
  return COG_META.find((option) => option.value === value)?.department ?? null;
};

export const getCogKey = (value) =>
  COG_META.find((option) => option.value === value)?.cogKey ?? toCogKey(value);

export const getCogAttacks = (value, level) => {
  if (!value || !level) return null;
  const department = getCogDepartment(value);
  const cogKey = getCogKey(value);
  const levelKey = String(level);
  return cogsData?.cogs?.[department]?.[cogKey]?.[levelKey]?.attacks ?? null;
};

export const getLevelOptions = (value) => {
  const rank = getCogRank(value);
  if (!rank) return [];
  const levels = [];
  for (let level = rank; level <= rank + 7; level += 1) {
    levels.push(level);
  }
  return levels;
};

export const getCogLabel = (value) =>
  COG_OPTIONS.find((option) => option.value === value)?.label ?? value;

export const getCogImageSrc = (value, options = {}) => {
  if (!value) return '';
  const filename = value === 'two-face' ? value : value.replace(/-/g, '_');
  const suffix = options?.skelecog ? '_s' : '';
  return getImageFromContext(cogImageContext, `${filename}${suffix}.png`);
};

export const getMaxHp = (level) => {
  const parsed = Number.parseInt(level, 10);
  if (Number.isNaN(parsed)) return 0;
  return HP_BY_LEVEL[parsed] ?? 0;
};

export const getCogDefense = (level, value) => {
  const parsed = Number.parseInt(level, 10);
  if (Number.isNaN(parsed)) return 0;
  const rank = getCogRank(value);
  if (rank === 1 && parsed === 4) return 12;
  if (rank === 1 && parsed === 5) return 15;
  if (parsed >= 14) return 65;
  return DEFENSE_BY_LEVEL[parsed] ?? 0;
};
